import React, { useState, useEffect } from 'react';
import useProductOptions from '../../hooks/useProductOptions';
import CustomizableNote from '../CustomizableNote';
import CartView from '../CartView';
import { useStore } from '../../context/StoreContext';

const ProductInfo = ({ productData, storeDetails, onAddToCart, onImageChange,cartItems }) => {
  const {
    selectedOptions,
    allOptions,
    availableOptions,
    allOptionsSelected,
    handleOptionChange,
    selectedVariant,
    activeImage,
    isProductUnavailable,
    getDiscountPercentage,
    isOptionAvailable
  } = useProductOptions(productData, storeDetails);
  const { addToCart } = useStore();
  const [customizableNote, setCustomizableNote] = useState('');
  const priceInfo = getDiscountPercentage();
  const [isTemporarilyOutOfStock, setIsTemporarilyOutOfStock] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (activeImage) {
      onImageChange(activeImage);
    }
  }, [activeImage]);

  useEffect(() => {
    const allOptionsHaveValue = Object.values(selectedOptions).every(option => option !== null);
    setIsTemporarilyOutOfStock(isProductUnavailable());
  }, [selectedOptions, isProductUnavailable]);

  const handleCustomizableNoteChange = (note) => {
    setCustomizableNote(note);
  };

 
  const handleAddToCart = () => {
    setIsLoading(true);
    if (checkAlreadyInCart()) {
      const payload = updateQuantityCart();
      addToCart(payload);
    } else {
      onAddToCart(selectedVariant, customizableNote);
    }
    setIsCartOpen(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  };

  const checkAlreadyInCart = () => {
    let alreadyInCart = false;

    cartItems?.map((cartItem) => {
      cartItem?.cart_items?.map((cart_item) => {
        if(cart_item?.product_variants?.id == selectedVariant?.id)
        {
          alreadyInCart = true
        }
       
      })

    })
    return alreadyInCart;
  }
  const updateQuantityCart = () => {
    let payload = {};
    cartItems?.map((cartItem) => {
      return cartItem?.cart_items?.map((cart_item) => {
        if (cart_item?.product_variants?.id == selectedVariant?.id) {
          payload = {
            brands: [
              {
                brand_user_id: cartItem?.brand_user?.id,
                products: [
                  {
                    product_id: cart_item?.products?.id,
                    variants: [
                      {
                        variant_id: cart_item?.product_variants?.id,
                        quantity: cart_item.cart_quantity + 1,
                      },
                    ],
                    customizableNote: cart_item?.customizable_note,
                  },
                ],
              },
            ],
          };
        }
      })
    })
    return payload;
  }

  const onlyAvailableVariantFunc = (vals, option) => {
    if (option === "option1") return vals; // No filtering needed for option1
  
    const availableVariants = productData.productDetails.product_variants
      .filter(variant => variant.status == 1) // Only available variants
      .map(variant => variant.title); // Extract titles for comparison

    const newval = []; // Result array (now optimized)
  
    for (const val of vals) {
      let searchString;
      
      if (option === 'option2') {
        searchString = `${selectedOptions.option1} / ${val}`;
      } else if (option === 'option3') {
        searchString = `${selectedOptions.option1} / ${selectedOptions.option2} / ${val}`;
      }
  
      // Check if any available variant includes the search string
      if (availableVariants.some(title => title.includes(searchString))) {
        newval.push(val); // Add to results if available
      }
    }
  
    return newval; // Return filtered values
  };
  

  useEffect(() => {
    // Only run if option1 has a selected value
    if (!selectedOptions.option1) return;
  
    const availableOption2 = onlyAvailableVariantFunc(allOptions['option2'], 'option2');
    
    // Reset option2 if current selection is unavailable
    if (!availableOption2.includes(selectedOptions.option2)) {
      handleOptionChange('option2', availableOption2[0]);
      // Also reset option3 since option2 changed
      handleOptionChange('option3', '');
    }
  }, [selectedOptions.option1]);
  
  useEffect(() => {
    // Only run if both option1 and option2 have selected values
    if (!selectedOptions.option1 || !selectedOptions.option2) return;
  
    const availableOption3 = onlyAvailableVariantFunc(allOptions['option3'], 'option3');
    
    // Reset option3 if current selection is unavailable
    if (!availableOption3.includes(selectedOptions.option3)) {
      handleOptionChange('option3', availableOption3[0] || '');
    }
  }, [selectedOptions.option1, selectedOptions.option2]);
  
  
 
  return (
    <div className="lg:w-1/2">
      <h1 className="text-3xl font-bold mb-2">{productData.productDetails.title}</h1>
      <div className="flex items-center mb-2">
        <img src={productData.productDetails.user.brand_details.store_logo} alt="Brand logo" className="w-6 h-6 mr-2" />
        <span>{productData.productDetails.user.brand_details.store_name}</span>
      </div>
      <div className="mb-4">
        {priceInfo.hasDiscount ? (
          <div>
            <span className="text-gray-500 line-through">${priceInfo.originalPrice}</span>
            <span className="ml-2 text-lg font-bold text-green-700">${priceInfo.discountedPrice}</span>
          </div>
        ) : (
          <span className="text-lg font-bold">${priceInfo.originalPrice}</span>
        )}
      </div>
      {(productData?.productDetails?.product_options[0]?.value !== "Default Title" && productData?.productDetails?.product_options[0]?.name !== "Title" && allOptions['option1'].length > 0) && (
        <div className="mb-4">
          {['option1', 'option2', 'option3'].map((optionKey, index) => {
            const optionName = productData.productDetails.product_options.sort((a,b)=>a.sequence - b.sequence)[index]?.name;
            if (!optionName || allOptions[optionKey].length === 0) return null;
            return (
              <div key={optionKey} className="mb-4">
                <p className="mb-2 font-semibold">{optionName}:</p>
                <div className="flex flex-wrap gap-2">
                  {onlyAvailableVariantFunc(allOptions[optionKey],optionKey).map((option) => {
                    const isAvailable = isOptionAvailable(optionKey, option);
                    return (
                      isAvailable && <button
                        key={option}
                        className={`px-4 py-2 border rounded ${selectedOptions[optionKey] === option
                          ? 'border-prm text-prm'
                          : 'border-gray-300 text-gray-700'
                          }`}
                        onClick={() => handleOptionChange(optionKey, option)}
                      >
                        <span
                          className={isAvailable ? '' : 'relative'}      
                        >
                          {option}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}


      {productData.productDetails.is_customizable && (
        <CustomizableNote
          limit={productData.productDetails.customizable_note_limit}
          placeholder={productData.productDetails.customizable_note}
          value={customizableNote}
          onChange={handleCustomizableNoteChange}
        />
      )}
      <button
        className={`w-full py-3 rounded-lg mb-4 text-lg font-semibold ${isTemporarilyOutOfStock
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-primary text-white hover:bg-primary transition-colors'
          }`}
        onClick={handleAddToCart}
        disabled={isTemporarilyOutOfStock}
      >
        {
          'Add to cart'
        }
        
      </button>

      {isTemporarilyOutOfStock && (
        <p className="text-red-500 mb-4">
          {allOptionsSelected ? 'Selected variant is out of stock' : 'Out of stock'}
        </p>
      )}

      <div className="bg-gray-100 p-3 rounded-lg text-sm">
      This item will ship from {productData.productDetails.user.brand_details.store_name} within {productData.productDetails.shipping_time?.replace('_days', ' ')?.replace('gt', '>')} days.
      </div>

      <CartView isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} loading={isLoading} />
    </div>
  );
};

export default ProductInfo;